import React from "react";
import { Grid, Input } from "semantic-ui-react";
import Slider from "react-rangeslider";
import "react-rangeslider/lib/index.css";

export default class RangeSlider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sliderVal: parseFloat(this.props.sliderValue),
        };
    }

    setValue = (e) => {
        let val = e.target.value;
        this.setState({ sliderVal: val }, () =>
            this.props.handleSlide(this.props.index, val)
        );
    };
    handleSlide = (val) => {
        if (countDecimals(val) > 2) {
            val = parseInt(val * 100, 0) / 100;
        }
        this.setState({ sliderVal: val }, () =>
            this.props.handleSlide(this.props.index, val)
        );
    };

    render() {
        // let isPortrait =
        //     this.props.mobileView || window.innerHeight > window.innerWidth;
        let componentStyles = {
            default: {},
            grid: {},
        };

        let sliderMax = parseFloat(this.props.slider.maxValue);
        let sliderMin = parseFloat(this.props.slider.minValue);
        let step = Math.pow(
            10,
            Math.max(-2, (sliderMax - sliderMin).toString().length - 3)
        );
        return (
            <div
                key={`slider-${this.props.index}`}
                style={componentStyles[this.props.layout]}
            >
                <Grid style={{ textAlign: "left" }}>
                    <Grid.Row style={{ paddingBottom: "5px" }}>
                        <Grid.Column width={10}>
                            <div
                                style={{
                                    fontWeight: "bold",
                                    fontSize: "1.25em",
                                }}
                            >
                                {this.props.slider.name}
                            </div>
                        </Grid.Column>
                        <Grid.Column width={6}>
                            <Input
                                fluid
                                onChange={this.setValue}
                                value={this.state.sliderVal}
                            />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Slider
                    min={sliderMin}
                    max={sliderMax}
                    step={step}
                    value={this.state.sliderVal}
                    onChangeStart={() => {
                        this.setState({
                            selectedSlider: this.props.index,
                        });
                    }}
                    onChange={this.handleSlide}
                    onChangeComplete={this.handleSlideComplete}
                />
            </div>
        );
    }
}

var countDecimals = function (value) {
    let text = value.toString();
    // verify if number 0.000005 is represented as "5e-6"
    if (text.indexOf("e-") > -1) {
        let [trail] = text.split("e-");
        let deg = parseInt(trail, 10);
        return deg;
    }
    // count decimals for number in representation like "0.123456"
    if (Math.floor(value) !== value) {
        return value.toString().split(".")[1].length || 0;
    }
    return 0;
};
